import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AdminAIFeatures from './AdminAIFeatures';
import messages from '../../../locale/jsonMessages';


export default async function action({ store, intl }) {

    const title = intl?.formatMessage(messages.manageAiFeature);
    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    return {
        title,
        component: <AdminLayout><AdminAIFeatures title={title} /></AdminLayout>,
    };
};